import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import LogsNavigation from "./components/LogsNavigation";
import UserLogsJobsPage from "./pages/Jobs";
import UserLogsMessageEventsPage from "./pages/MessageEvents";
import UserLogsRequestItemsPage from "./pages/RequestItems";

const UserLogsPage = (props: RouteComponentProps) => {
	return (
		<div className="page-container">
			<LogsNavigation />
			<Switch>
				<Route path={`${props.match.url}/requests`} component={UserLogsRequestItemsPage} />
				<Route path={`${props.match.url}/message_events`} component={UserLogsMessageEventsPage} />
				<Route path={`${props.match.url}/jobs`} component={UserLogsJobsPage} />
				<Redirect from={props.match.url} exact to={`${props.match.url}/message_events`} />
			</Switch>
		</div>
	);
};

export default UserLogsPage;
